module.exports = __webpack_public_path__ + "img/20180815_145537_014.45bc89ee.jpg";